/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetIntelligenceKpisPortfolioHistoryParams,
  GetIntelligenceKpisPortfolioParams,
  GetIntelligenceKpisProjectProjectIdHistoryParams,
  GetIntelligenceKpisProjectProjectIdParams,
  KpiDefinitionDto,
  KpiHistoryDto,
  KpiValueDto,
  PortfolioHistoryDto,
  PortfolioProjectDto,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Definitions
 */
export const getIntelligenceKpisDefinitions = (signal?: AbortSignal) => {
  return customInstance<KpiDefinitionDto[]>({
    url: `/intelligence/kpis/definitions`,
    method: "GET",
    signal,
  });
};

export const getGetIntelligenceKpisDefinitionsInfiniteQueryKey = () => {
  return ["infinite", `/intelligence/kpis/definitions`] as const;
};

export const getGetIntelligenceKpisDefinitionsQueryKey = () => {
  return [`/intelligence/kpis/definitions`] as const;
};

export const getGetIntelligenceKpisDefinitionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  >,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisDefinitionsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  > = ({ signal }) => getIntelligenceKpisDefinitions(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisDefinitionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
>;
export type GetIntelligenceKpisDefinitionsInfiniteQueryError = void;

export function useGetIntelligenceKpisDefinitionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  >,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisDefinitionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisDefinitionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Definitions
 */

export function useGetIntelligenceKpisDefinitionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceKpisDefinitionsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceKpisDefinitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntelligenceKpisDefinitionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
  > = ({ signal }) => getIntelligenceKpisDefinitions(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisDefinitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
>;
export type GetIntelligenceKpisDefinitionsQueryError = void;

export function useGetIntelligenceKpisDefinitions<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisDefinitions<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisDefinitions<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Definitions
 */

export function useGetIntelligenceKpisDefinitions<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisDefinitions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceKpisDefinitionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Portfolio
 */
export const getIntelligenceKpisPortfolio = (
  params?: GetIntelligenceKpisPortfolioParams,
  signal?: AbortSignal,
) => {
  return customInstance<PortfolioProjectDto[]>({
    url: `/intelligence/kpis/portfolio`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetIntelligenceKpisPortfolioInfiniteQueryKey = (
  params?: GetIntelligenceKpisPortfolioParams,
) => {
  return [
    "infinite",
    `/intelligence/kpis/portfolio`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisPortfolioQueryKey = (
  params?: GetIntelligenceKpisPortfolioParams,
) => {
  return [`/intelligence/kpis/portfolio`, ...(params ? [params] : [])] as const;
};

export const getGetIntelligenceKpisPortfolioInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisPortfolioInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  > = ({ signal }) => getIntelligenceKpisPortfolio(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisPortfolioInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
>;
export type GetIntelligenceKpisPortfolioInfiniteQueryError = void;

export function useGetIntelligenceKpisPortfolioInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  >,
  TError = void,
>(
  params: undefined | GetIntelligenceKpisPortfolioParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolioInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolioInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Portfolio
 */

export function useGetIntelligenceKpisPortfolioInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceKpisPortfolioInfiniteQueryOptions(
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceKpisPortfolioQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntelligenceKpisPortfolioQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
  > = ({ signal }) => getIntelligenceKpisPortfolio(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisPortfolioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
>;
export type GetIntelligenceKpisPortfolioQueryError = void;

export function useGetIntelligenceKpisPortfolio<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
  TError = void,
>(
  params: undefined | GetIntelligenceKpisPortfolioParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolio<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolio<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Portfolio
 */

export function useGetIntelligenceKpisPortfolio<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolio>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceKpisPortfolioQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Portfolio History
 */
export const getIntelligenceKpisPortfolioHistory = (
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  signal?: AbortSignal,
) => {
  return customInstance<PortfolioHistoryDto[]>({
    url: `/intelligence/kpis/portfolio/history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetIntelligenceKpisPortfolioHistoryInfiniteQueryKey = (
  params?: GetIntelligenceKpisPortfolioHistoryParams,
) => {
  return [
    "infinite",
    `/intelligence/kpis/portfolio/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisPortfolioHistoryQueryKey = (
  params?: GetIntelligenceKpisPortfolioHistoryParams,
) => {
  return [
    `/intelligence/kpis/portfolio/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisPortfolioHistoryInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisPortfolioHistoryInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  > = ({ signal }) => getIntelligenceKpisPortfolioHistory(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisPortfolioHistoryInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>>;
export type GetIntelligenceKpisPortfolioHistoryInfiniteQueryError = void;

export function useGetIntelligenceKpisPortfolioHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  >,
  TError = void,
>(
  params: undefined | GetIntelligenceKpisPortfolioHistoryParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolioHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolioHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Portfolio History
 */

export function useGetIntelligenceKpisPortfolioHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  >,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceKpisPortfolioHistoryInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceKpisPortfolioHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisPortfolioHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
  > = ({ signal }) => getIntelligenceKpisPortfolioHistory(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisPortfolioHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
>;
export type GetIntelligenceKpisPortfolioHistoryQueryError = void;

export function useGetIntelligenceKpisPortfolioHistory<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
  TError = void,
>(
  params: undefined | GetIntelligenceKpisPortfolioHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolioHistory<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisPortfolioHistory<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Portfolio History
 */

export function useGetIntelligenceKpisPortfolioHistory<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
  TError = void,
>(
  params?: GetIntelligenceKpisPortfolioHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisPortfolioHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceKpisPortfolioHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Project
 */
export const getIntelligenceKpisProjectProjectId = (
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  signal?: AbortSignal,
) => {
  return customInstance<KpiValueDto[]>({
    url: `/intelligence/kpis/project/${projectId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetIntelligenceKpisProjectProjectIdInfiniteQueryKey = (
  projectId?: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
) => {
  return [
    "infinite",
    `/intelligence/kpis/project/${projectId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisProjectProjectIdQueryKey = (
  projectId?: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
) => {
  return [
    `/intelligence/kpis/project/${projectId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisProjectProjectIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisProjectProjectIdInfiniteQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  > = ({ signal }) =>
    getIntelligenceKpisProjectProjectId(projectId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisProjectProjectIdInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>>;
export type GetIntelligenceKpisProjectProjectIdInfiniteQueryError = void;

export function useGetIntelligenceKpisProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  params: undefined | GetIntelligenceKpisProjectProjectIdParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Project
 */

export function useGetIntelligenceKpisProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceKpisProjectProjectIdInfiniteQueryOptions(
      projectId,
      params,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceKpisProjectProjectIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisProjectProjectIdQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
  > = ({ signal }) =>
    getIntelligenceKpisProjectProjectId(projectId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisProjectProjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
>;
export type GetIntelligenceKpisProjectProjectIdQueryError = void;

export function useGetIntelligenceKpisProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  params: undefined | GetIntelligenceKpisProjectProjectIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Project
 */

export function useGetIntelligenceKpisProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceKpisProjectProjectIdQueryOptions(
    projectId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary History
 */
export const getIntelligenceKpisProjectProjectIdHistory = (
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  signal?: AbortSignal,
) => {
  return customInstance<KpiHistoryDto[]>({
    url: `/intelligence/kpis/project/${projectId}/history`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetIntelligenceKpisProjectProjectIdHistoryInfiniteQueryKey = (
  projectId?: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
) => {
  return [
    "infinite",
    `/intelligence/kpis/project/${projectId}/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisProjectProjectIdHistoryQueryKey = (
  projectId?: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
) => {
  return [
    `/intelligence/kpis/project/${projectId}/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntelligenceKpisProjectProjectIdHistoryInfiniteQueryOptions =
  <
    TData = InfiniteData<
      Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
    >,
    TError = void,
  >(
    projectId: number,
    params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
    options?: {
      query?: Partial<
        UseInfiniteQueryOptions<
          Awaited<
            ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIntelligenceKpisProjectProjectIdHistoryInfiniteQueryKey(
        projectId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
    > = ({ signal }) =>
      getIntelligenceKpisProjectProjectIdHistory(projectId, params, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!projectId,
      staleTime: 10000,
      refetchOnWindowFocus: false,
      ...queryOptions,
    } as UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetIntelligenceKpisProjectProjectIdHistoryInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
  >;
export type GetIntelligenceKpisProjectProjectIdHistoryInfiniteQueryError = void;

export function useGetIntelligenceKpisProjectProjectIdHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
  >,
  TError = void,
>(
  projectId: number,
  params: undefined | GetIntelligenceKpisProjectProjectIdHistoryParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
          >,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectIdHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
          >,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectIdHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary History
 */

export function useGetIntelligenceKpisProjectProjectIdHistoryInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceKpisProjectProjectIdHistoryInfiniteQueryOptions(
      projectId,
      params,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceKpisProjectProjectIdHistoryQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceKpisProjectProjectIdHistoryQueryKey(projectId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
  > = ({ signal }) =>
    getIntelligenceKpisProjectProjectIdHistory(projectId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceKpisProjectProjectIdHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
>;
export type GetIntelligenceKpisProjectProjectIdHistoryQueryError = void;

export function useGetIntelligenceKpisProjectProjectIdHistory<
  TData = Awaited<
    ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
  >,
  TError = void,
>(
  projectId: number,
  params: undefined | GetIntelligenceKpisProjectProjectIdHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
          >,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectIdHistory<
  TData = Awaited<
    ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
          >,
          TError,
          Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceKpisProjectProjectIdHistory<
  TData = Awaited<
    ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary History
 */

export function useGetIntelligenceKpisProjectProjectIdHistory<
  TData = Awaited<
    ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>
  >,
  TError = void,
>(
  projectId: number,
  params?: GetIntelligenceKpisProjectProjectIdHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceKpisProjectProjectIdHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceKpisProjectProjectIdHistoryQueryOptions(
      projectId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Recompute
 */
export const postIntelligenceKpisProjectProjectIdRecompute = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/intelligence/kpis/project/${projectId}/recompute`,
    method: "POST",
    signal,
  });
};

export const getPostIntelligenceKpisProjectProjectIdRecomputeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntelligenceKpisProjectProjectIdRecompute>>,
    TError,
    { projectId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntelligenceKpisProjectProjectIdRecompute>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationKey = ["postIntelligenceKpisProjectProjectIdRecompute"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntelligenceKpisProjectProjectIdRecompute>>,
    { projectId: number }
  > = (props) => {
    const { projectId } = props ?? {};

    return postIntelligenceKpisProjectProjectIdRecompute(projectId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntelligenceKpisProjectProjectIdRecomputeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postIntelligenceKpisProjectProjectIdRecompute>>
  >;

export type PostIntelligenceKpisProjectProjectIdRecomputeMutationError = void;

/**
 * @summary Recompute
 */
export const usePostIntelligenceKpisProjectProjectIdRecompute = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postIntelligenceKpisProjectProjectIdRecompute>>,
      TError,
      { projectId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postIntelligenceKpisProjectProjectIdRecompute>>,
  TError,
  { projectId: number },
  TContext
> => {
  const mutationOptions =
    getPostIntelligenceKpisProjectProjectIdRecomputeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
